import MainStackNavigator from './mainStackNavigator'
export default MainStackNavigator
